import script from "./BaseTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplate.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplate.vue?vue&type=style&index=0&id=bf41044c&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf41044c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QDialog});
